export default __webpack_public_path__ + "static/media/bg.a00072ae.jpg";